import { MerchandiserDashboard, type MerchandiserSummary } from "./MerchandiserDashboard";

export type TextileSummary = MerchandiserSummary;

/** Textile order figures shown in the dashboards' top tiles (same scope as the rest of the dashboard) */
export interface OrderKpis {
  orders_booked: number;
  order_value: number;
  orders_booked_prev: number;
  order_value_prev: number;
  dispatched_value: number;
  dispatches: number;
  order_book_value: number;
  order_book_orders: number;
  /** Share of consignment lines in the last 90 days sent by their delivery date; null when none had a date */
  on_time_pct: number | null;
  on_time_lines: number;
  late_lines: number;
}

/** "92% on time" hint text: how many lines and how many were late */
export const onTimeHint = (o: OrderKpis) =>
  o.on_time_pct === null ? "No dated consignments in the last 90 days" : `Last 90 days · ${o.on_time_lines + o.late_lines} lines, ${o.late_lines} late`;

/** Samples, dispatch and complaints, shown at the top of the sales dashboards (scoped to what the viewer can see) */
export function TextileBlock({ data, scope }: { data: TextileSummary; scope: string }) {
  return (
    <section className="space-y-3">
      <div>
        <h2 className="text-sm font-bold">Samples, dispatch and complaints</h2>
        <p className="text-xs text-muted-foreground">{scope}</p>
      </div>
      <MerchandiserDashboard data={data} />
    </section>
  );
}
